import {$api} from "../http";

export default class AddressService {
    static async createAddress(street, home, korp, entrance, apartment, koment) {
        return  $api.post('api/address', {street, home, korp, entrance, apartment, koment})
    }


}